<div id="playlistItemModal">
  <form
    #playlistItemForm="ngForm"
    id="playlistItemForm"
    role="form"
    name="forms.playlistItemForm"
    (keyup.enter)="save()"
    novalidate
  >
    <div class="tw-flex tw-justify-end tw-mr-2">
      <button
        type="button"
        mat-icon-button
        class="close"
        (click)="dismiss()"
        aria-label="Close this modal"
      >
        <streamline-icon name="close" width="12" height="12"></streamline-icon>
      </button>
    </div>
    <h4 class="tw-text-center">Edit Playlist Item</h4>
    <mat-dialog-content>
      <div class="panel" [shown]="isDeprecatedItem">
        <div class="panel-body bg-warning">
          <p class="u_remove-bottom">
            This item is deprecated and you must
            <a
              href="https://help.risevision.com/hc/en-us/articles/360001275603-How-do-I-update-the-deprecated-content-items-in-my-presentation-"
              target="_blank"
              class="madero-link"
              >replace it</a
            >
            with its corresponding Widget as soon as possible.
          </p>
        </div>
      </div>
      <div class="form-group">
        <label class="control-label">Name</label>
        <input
          type="text"
          name="name"
          class="form-control"
          [(ngModel)]="_item.name"
        />
      </div>
      <div class="form-group" [shown]="widgetName">
        <label class="control-label">Widget:</label>
        <br />
        <a id="widgetName" class="link" actionLink (click)="showSettingsModal()"
          >{{ widgetName
          }}<i aria-hidden="true" class="fa fa-cog icon-right"></i
        ></a>
      </div>
      <rv-divider />
      <div class="form-group u_margin-sm-top">
        <label class="control-label" for="playlist-item-pud">Duration:</label>
        <div class="flex-row">
          <mat-checkbox
            name="playUntilDone"
            [(ngModel)]="_item.playUntilDone"
            ngDefaultControl
          ></mat-checkbox>
          <span class="control-label tw-mr-6">Play Until Done</span>
        </div>
      </div>
      @if (!_item.playUntilDone) {
        <div>
          <div class="input-group">
            <input
              #duration="ngModel"
              type="number"
              id="duration"
              name="duration"
              class="form-control"
              [(ngModel)]="_item.duration"
              required
              min="1"
              placeholder="Enter duration"
            />
            <span class="input-group-addon">Seconds</span>
          </div>
          <span class="text-danger" [shown]="duration.invalid"> Required </span>
        </div>
      }
      <div class="attribute-editor-row tw-mt-8">
        <label class="control-label">Timeline:</label>
        <timeline-textbox
          [timelineObject]="_item"
          inputId="-playlistItem"
        ></timeline-textbox>
      </div>
      <div class="attribute-editor-row tw-mt-8">
        <label class="control-label">Distribution:</label>
        <distribution-selector
          [(distribution)]="_item.distribution"
          [(distributeToAll)]="_item.distributeToAll"
        ></distribution-selector>
      </div> </mat-dialog-content
    ><!--modal-body-->
    <mat-dialog-actions align="end">
      <button matButton="outlined" (click)="dismiss()">Cancel</button>
      <button
        id="playlistItemSave"
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="playlistItemForm.invalid"
      >
        Apply
      </button>
    </mat-dialog-actions>
  </form>
</div>
